import React from "react";

interface RowBasicProps {
  title: string;
  accessoryTitle: string;
}

const RowBasic = (props: RowBasicProps) => {
  const { title, accessoryTitle } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={styles.title}>{title}</div>
      <div style={styles.accessory}>{accessoryTitle}</div>
    </div>
  );
};

const styles = {
  title: { flex: 6, textAlign: "start" as const },
  accessory: { flex: 1, textAlign: "end" as const },
};

export default RowBasic;
